/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';

// style imports
import './Footer.scss';

/**
 * defines footer when needed is made
 * 
 * @param props
 * 
 * @returns html to render footer message if available after login
 * 
**/

export class Footer extends Component {
    render () {
        return (
            <div className="d-flex flex-row align-items-center justify-content-center footer-box">
                <span>Footer content comes here</span>
            </div>
        );
    }
}